import React from "react";
import { CategoryIcon } from "@utils/utils";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import CategoryCardStatusChip from "./CategoryCardStatusChip";
export const CategoryCardTitle = ({ categoryType, categoryName, categoryChange, categoryIcon, isCategoryReviewPositive, }) => {
    return (React.createElement(PeekStack, { direction: "row", spacing: 0.5, alignItems: "center" },
        categoryIcon ? categoryIcon : React.createElement(CategoryIcon, { categoryType: categoryType }),
        React.createElement(PeekTypography, { variant: "h2", fontWeight: "fontWeightLight" }, categoryName),
        React.createElement(CategoryCardStatusChip, { categoryChange: categoryChange, isCategoryReviewPositive: isCategoryReviewPositive })));
};
export default CategoryCardTitle;
